import { render, staticRenderFns } from "./jackpot.vue?vue&type=template&id=2d2d6ccc&scoped=true&"
import script from "./jackpot.vue?vue&type=script&lang=ts&"
export * from "./jackpot.vue?vue&type=script&lang=ts&"
import style0 from "./jackpot.vue?vue&type=style&index=0&id=2d2d6ccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d6ccc",
  null
  
)

export default component.exports